import { Check, ImageUp, KeyRound, MessagesSquare, ScanSearch, WandSparkles } from 'lucide-react';

const steps = [
  { label: 'تصویر اتاق', icon: ImageUp }, { label: 'احراز هویت', icon: KeyRound },
  { label: 'گفتگو', icon: MessagesSquare }, { label: 'پیش‌نمایش', icon: ScanSearch }, { label: 'طراحی نهایی', icon: WandSparkles },
];

export function FlowStepper({ active }: { active: number }) {
  const safeActive = Math.min(Math.max(active, 0), steps.length - 1);
  const CurrentIcon = steps[safeActive].icon;

  return <nav className="design-progress" aria-label="مراحل طراحی">
    <div className="design-progress-current">
      <span className="step-icon"><CurrentIcon size={18} /></span>
      <span><small>مرحله {(safeActive + 1).toLocaleString('fa-IR')} از {steps.length.toLocaleString('fa-IR')}</small><strong>{steps[safeActive].label}</strong></span>
    </div>
    <ol className="stepper">{steps.map((step, index) => {
      const Icon = step.icon; const complete = index < safeActive; const current = index === safeActive;
      return <li key={step.label} className={`${complete ? 'complete' : ''} ${current ? 'active' : ''}`} aria-current={current ? 'step' : undefined}>
        <span className="step-icon">{complete ? <Check size={17} /> : <Icon size={17} />}</span><span>{step.label}</span>
      </li>;
    })}</ol>
    <div className="design-progress-track" role="progressbar" aria-label="پیشرفت طراحی" aria-valuemin={1} aria-valuemax={steps.length} aria-valuenow={safeActive + 1}>
      <i style={{ width: `${((safeActive + 1) / steps.length) * 100}%` }} />
    </div>
  </nav>;
}
